import ButtonLarge from 'common/ButtonLarge';
import CreateText from 'common/CreateText';
import ButtonLoader from 'common/Loaders/ButtonLoader';
import styled from 'styled-components';

import React from 'react';

const ContainerDiv = styled.div`
    background: ${(props) => props.theme.colorBackground};
    width: 100%;
    height: 100%;
    min-height: 400px;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .button {
        padding: 0px 60px;
    }

    .text {
        margin: 22px 0px;
    }
`;

const EmptyReceivingAccount = ({ onSetup, isLoading }) => {
    return (
        <ContainerDiv>
            <div>
                <svg width="44" height="44" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20 20H4C2.89543 20 2 19.1046 2 18V6C2 4.89543 2.89543 4 4 4H20C21.1046 4 22 4.89543 22 6V18C22 19.1046 21.1046 20 20 20ZM4 6V18H20V6H4ZM15.5 16C14.1193 16 13 14.8807 13 13.5C13 12.1193 14.1193 11 15.5 11C16.8807 11 18 12.1193 18 13.5C18 14.163 17.7366 14.7989 17.2678 15.2678C16.7989 15.7366 16.163 16 15.5 16ZM11.5 16C10.1193 16 9 14.8807 9 13.5C9 12.1193 10.1193 11 11.5 11C12.0428 11.0004 12.5702 11.1805 13 11.512C12.3713 11.9791 12.0006 12.7162 12.0006 13.4995C12.0006 14.2828 12.3713 15.0199 13 15.487C12.5703 15.8189 12.0429 15.9993 11.5 16Z" fill="#C4C4C4"/>
                </svg>
            </div>

            <div style={{ textAlign: 'center', maxWidth: '500px' }}>
                <CreateText className="text">
                    Set up your Stripe account to receive payments
                </CreateText>
            </div>

            <div style={{ 
                textAlign: 'center', 
                maxWidth: '500px', 
                marginBottom: '32px',
                color: '#666',
                fontSize: '16px',
                lineHeight: '1.5',
                fontFamily: 'Poppins, sans-serif'
            }}>
                Connect a Stripe business account to start accepting payments and sending invoices to your patients. 
                Stripe securely processes payments and deposits funds directly to your bank account.
            </div>

            <div>
                {isLoading ? (
                    <ButtonLoader />
                ) : (
                    <ButtonLarge onClick={onSetup} className="button">
                        Set Up Receiving Account
                    </ButtonLarge>
                )}
            </div>
        </ContainerDiv>
    );
};

export default EmptyReceivingAccount;
